import { render, staticRenderFns } from "./hdOrderlPrint.vue?vue&type=template&id=2a6f1c20&scoped=true"
import script from "./hdOrderlPrint.vue?vue&type=script&lang=js"
export * from "./hdOrderlPrint.vue?vue&type=script&lang=js"
import style0 from "./hdOrderlPrint.vue?vue&type=style&index=0&id=2a6f1c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f1c20",
  null
  
)

export default component.exports